<template>
  <div
      id="customer_success_settings"
      class="flex flex-col size-full justify-between overflow-hidden"
  >
    <div class="flex flex-grow flex-col px-[100px] overflow-hidden">
      <div class="pt-2 flex flex-col gap-5 h-full overflow-hidden">
        <div class="flex justify-between items-center gap-4 flex-shrink-0">
          <h1 class="text_color text-xl font-semibold">Customer Success</h1>
        </div>

        <div class="flex flex-row items-center gap-2 flex-shrink-0">
          <div
              @click="switchView(settingsTabs.MANAGE_DATA)"
              :class="[
              'flex gap-2 rounded-lg secondary_color cursor-pointer items-center justify-center py-[10px]',
              currentView === settingsTabs.MANAGE_DATA
                ? 'selected-bar font-semibold px-[13px]'
                : 'px-[15px]',
            ]"
          >
            <span class="text-[15px]">Manage Data</span>
          </div>
          <div
              @click="switchView(settingsTabs.AI_HEALTH_SCORE)"
              :class="[
              'flex gap-2 rounded-lg secondary_color cursor-pointer items-center justify-center py-[10px]',
              currentView === settingsTabs.AI_HEALTH_SCORE
                ? 'selected-bar font-semibold px-[13px]'
                : 'px-[15px]',
            ]"
          >
            <span class="text-[15px]">AI Health Score</span>
          </div>
        </div>

        <div v-if="currentView === settingsTabs.MANAGE_DATA"
             class="flex flex-col gap-6 pl-3 pr-20 max-h-[calc(100vh-290px)] overflow-y-scroll">
          <div class="flex flex-col gap-3">
            <span class="text_color text-lg font-semibold">Manage Data</span>
          </div>

          <div class="flex flex-col gap-6">
            <div class="flex flex-col gap-4">
              <span class="text_color text-[15px] font-semibold">Summary</span>
              <div class="flex flex-col gap-2">
                <label class="secondary_color text-sm">Dashboard to display</label>
                <a-select
                    v-model:value="formState.dashboard_id"
                    show-search
                    placeholder="Select dashboard"
                >
                  <template #suffixIcon>
                    <ThemeImage
                        :icon="imageNames.BOTTOM_ARROW"
                        alt="bottom_white_arrow"
                        class="size-4"
                    />
                  </template>
                  <a-select-option
                      v-for="dashboard in dashboards"
                      :key="dashboard.id"
                      :value="dashboard.id"
                  >
                    {{ dashboard.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>

            <div class="flex flex-col gap-4">
              <span class="text_color text-[15px] font-semibold">Customers</span>
              <div class="flex flex-row gap-3">
                <div class="flex flex-col gap-2 flex-1">
                  <label class="secondary_color text-sm">Default view to display</label>
                  <a-select
                      v-model:value="formState.default_view_id"
                      show-search
                      placeholder="Select default view"
                  >
                    <template #suffixIcon>
                      <ThemeImage
                          :icon="imageNames.BOTTOM_ARROW"
                          alt="bottom_white_arrow"
                          class="size-4"
                      />
                    </template>
                    <a-select-option
                        v-for="view in customerViews"
                        :key="view.id"
                        :value="view.id"
                    >
                      {{ view.name }}
                    </a-select-option>
                  </a-select>
                </div>
                <div class="flex flex-col gap-2 flex-1">
                  <label class="secondary_color text-sm">Onboarding view to display</label>
                  <a-select
                      v-model:value="formState.onboarding_view_id"
                      show-search
                      placeholder="Select onboarding view"
                  >
                    <template #suffixIcon>
                      <ThemeImage
                          :icon="imageNames.BOTTOM_ARROW"
                          alt="bottom_white_arrow"
                          class="size-4"
                      />
                    </template>
                    <a-select-option
                        v-for="view in customerViews"
                        :key="view.id"
                        :value="view.id"
                    >
                      {{ view.name }}
                    </a-select-option>
                  </a-select>
                </div>
              </div>
            </div>

            <div class="flex flex-col gap-4">
              <span class="text_color text-[15px] font-semibold">Deals</span>
              <div class="flex flex-col gap-2">
                <label class="secondary_color text-sm">Deals pipeline to display</label>
                <a-select
                    v-model:value="formState.pipeline_id"
                    show-search
                    placeholder="Select pipeline"
                >
                  <template #suffixIcon>
                    <ThemeImage
                        :icon="imageNames.BOTTOM_ARROW"
                        alt="bottom_white_arrow"
                        class="size-4"
                    />
                  </template>
                  <a-select-option
                      v-for="pipeline in pipelines"
                      :key="pipeline.id"
                      :value="pipeline.id"
                  >
                    {{ pipeline.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>

            <div class="flex flex-col gap-4">
              <span class="text_color text-[15px] font-semibold">Tasks</span>
              <div class="flex flex-row gap-3">
                <div class="flex flex-col gap-2 flex-1">
                  <label class="secondary_color text-sm">Default task view to display</label>
                  <a-select
                      v-model:value="formState.task_view_id"
                      show-search
                      placeholder="Select task view"
                  >
                    <template #suffixIcon>
                      <ThemeImage
                          :icon="imageNames.BOTTOM_ARROW"
                          alt="bottom_white_arrow"
                          class="size-4"
                      />
                    </template>
                    <a-select-option
                        v-for="view in taskViews"
                        :key="view.id"
                        :value="view.id"
                    >
                      {{ view.name }}
                    </a-select-option>
                  </a-select>
                </div>
              </div>
            </div>
          </div>
          <div class="h-[10vh] w-full"></div>
        </div>
        <div v-if="currentView === settingsTabs.AI_HEALTH_SCORE" class="flex flex-col gap-6 px-3">
          <div class="flex flex-col gap-3">
            <div class="flex justify-between items-center">
              <span class="text_color text-lg font-semibold">AI Health Score</span>
              <a-switch v-model:checked="scoringEnabled" />
            </div>
            <span class="text_color text-sm font-normal">
              Write your score criteria so the AI can define your customers score within a range of <b>0 to 100</b>
            </span>
          </div>

          <a-textarea
              v-model:value="aiHealthScore"
              class="textarea_large"
              :rows="10"
              placeholder="Enter AI health score criteria..."
              :disabled="!scoringEnabled"
          />
        </div>
      </div>
    </div>
  </div>

  <div
      class="flex flex-row justify-end gap-2 border_top py-6 px-[8vw] flex-shrink-0"
      style="margin-left: -8vw; margin-right: -8vw"
  >
    <a-button class="secondary_medium" @click="handleCancel"
    >Cancel
    </a-button
    >
    <a-button
        class="primary_medium"
        :loading="isUpdating"
        @click="handleSaveChanges"
    >Save changes
    </a-button>
  </div>
</template>

<script setup>
import {computed, onMounted, reactive, ref} from "vue";
import DashboardService from "@/src/api/DashboardService.js";
import CustomerSuccessService from "@/src/api/CustomerSuccessService.js";
import CRMService from "@/src/api/CRMService.js";
import ThemeImage from "@/src/components/ThemeImage.vue";
import {imageNames} from "@/src/constants/imageConstants.js";
import {message} from "ant-design-vue";

const settingsTabs = {
  MANAGE_DATA: "manage_data",
  AI_HEALTH_SCORE: "ai_health_score"
};

const currentView = ref(settingsTabs.MANAGE_DATA);

const isUpdating = ref(false);

const loadingPipelines = ref(false);
const loadingDashboards = ref(false);
const loadingViews = ref(false);
const loadingTaskViews = ref(false);

const pipelines = ref([]);
const dashboards = ref([]);
const customerViews = ref([]);
const taskViews = ref([]);

const formState = reactive({
  pipeline_id: null,
  task_view_id: null,
  dashboard_id: null,
  onboarding_view_id: null,
  default_view_id: null
});

const aiHealthScore = ref("");
const initialAiHealthScore = ref("");
const scoringEnabled = ref(false);
const initialScoringEnabled = ref(false);

const initialApiFormData = reactive({
  pipeline_id: null,
  task_view_id: null,
  dashboard_id: null,
  onboarding_view_id: null,
  default_view_id: null
});

const switchView = (view) => {
  currentView.value = view;
};

const handleCancel = () => {
  formState.pipeline_id = initialApiFormData.pipeline_id;
  formState.task_view_id = initialApiFormData.task_view_id;
  formState.dashboard_id = initialApiFormData.dashboard_id;
  formState.onboarding_view_id = initialApiFormData.onboarding_view_id;
  formState.default_view_id = initialApiFormData.default_view_id;
  aiHealthScore.value = initialAiHealthScore.value;
  scoringEnabled.value = initialScoringEnabled.value;
};

const handleSaveChanges = async () => {
  try {
    isUpdating.value = true;

    await updateModuleConfiguration();

    message.success('Customer Success settings updated successfully!');

    initialApiFormData.pipeline_id = formState.pipeline_id;
    initialApiFormData.task_view_id = formState.task_view_id;
    initialApiFormData.dashboard_id = formState.dashboard_id;
    initialApiFormData.onboarding_view_id = formState.onboarding_view_id;
    initialApiFormData.default_view_id = formState.default_view_id;
    initialAiHealthScore.value = aiHealthScore.value;
    initialScoringEnabled.value = scoringEnabled.value;
  } catch (error) {
    console.error('An error occurred while updating settings: ', error);
    message.error('An error occurred while updating settings');
  } finally {
    isUpdating.value = false;
  }
};

const fetchModuleConfiguration = async () => {
  try {
    const response = await CustomerSuccessService.fetchConfiguration();

    if (response?.success && response?.data) {
      aiHealthScore.value = response.data.ai_health_criteria || "";
      initialAiHealthScore.value = response.data.ai_health_criteria || "";
      
      scoringEnabled.value = response.data.scoring_enabled ?? false;
      initialScoringEnabled.value = response.data.scoring_enabled ?? false;

      const config = response.data.additional_config || {};

      formState.pipeline_id = config.customer_success_pipeline_id || null;
      formState.task_view_id = config.customer_success_task_view_id || null;
      formState.dashboard_id = config.customer_success_dashboard_id || null;
      formState.onboarding_view_id = config.customer_success_onboarding_view_id || null;
      formState.default_view_id = config.customer_success_default_view_id || null;

      initialApiFormData.pipeline_id = config.customer_success_pipeline_id || null;
      initialApiFormData.task_view_id = config.customer_success_task_view_id || null;
      initialApiFormData.dashboard_id = config.customer_success_dashboard_id || null;
      initialApiFormData.onboarding_view_id = config.customer_success_onboarding_view_id || null;
      initialApiFormData.default_view_id = config.customer_success_default_view_id || null;
    }
  } catch (error) {
    console.error("An error occurred while fetching customer success configuration: ", error);
  }
};

const updateModuleConfiguration = async () => {
  try {
    const payload = {
      ai_health_criteria: aiHealthScore.value,
      additional_config: {
        customer_success_pipeline_id: formState.pipeline_id,
        customer_success_task_view_id: formState.task_view_id,
        customer_success_onboarding_view_id: formState.onboarding_view_id,
        customer_success_default_view_id: formState.default_view_id,
        customer_success_dashboard_id: formState.dashboard_id
      },
      scoring_enabled: scoringEnabled.value
    };

    const response = await CustomerSuccessService.updateConfiguration(payload);

    if (!response?.success) {
      throw new Error("Failed to update module configuration");
    }
  } catch (error) {
    console.error("An error occurred while updating module configuration: ", error);
    throw error;
  }
};

const fetchPipelines = async () => {
  try {
    loadingPipelines.value = true;
    const response = await DashboardService.fetchPipelines();

    if (response?.success && response?.pipelines) {
      pipelines.value = response.pipelines;
    }
  } catch (error) {
    console.error("An error occurred while fetching pipelines: ", error);
  } finally {
    loadingPipelines.value = false;
  }
};

const fetchDashboards = async () => {
  try {
    loadingDashboards.value = true;
    const response = await DashboardService.builder.fetchDashboards();

    if (response?.success && response?.data?.dashboards) {
      dashboards.value = response.data.dashboards;
    }
  } catch (error) {
    console.error("An error occurred while fetching dashboards: ", error);
  } finally {
    loadingDashboards.value = false;
  }
};

const fetchCustomerViews = async () => {
  try {
    loadingViews.value = true;
    const response = await CRMService.fetchDynamicEntityViews('customers', null, 'customer_success');

    if (response) {
      const data = response.data || response;
      const allViews = [
        ...(data.activeViews || []),
        ...(data.inActiveViews || [])
      ];
      customerViews.value = allViews;
    }
  } catch (error) {
    console.error("An error occurred while fetching customer views: ", error);
  } finally {
    loadingViews.value = false;
  }
};

const fetchTaskViews = async () => {
  try {
    loadingTaskViews.value = true;
    const response = await CRMService.fetchDynamicEntityViews('crm_tasks', null, 'customer_success');

    if (response) {
      const data = response.data || response;
      const allViews = [
        ...(data.activeViews || []),
        ...(data.inActiveViews || [])
      ];
      taskViews.value = allViews;
    }
  } catch (error) {
    console.error("An error occurred while fetching task views: ", error);
  } finally {
    loadingTaskViews.value = false;
  }
};


const validateFormValues = () => {
  const optionIds = {
    pipeline_id: pipelines.value.map(p => p.id),
    dashboard_id: dashboards.value.map(d => d.id),
    default_view_id: customerViews.value.map(v => v.id),
    onboarding_view_id: customerViews.value.map(v => v.id),
    task_view_id: taskViews.value.map(v => v.id),
  };

  for (const [key, ids] of Object.entries(optionIds)) {
    if (formState[key] && !ids.includes(formState[key])) {
      formState[key] = null;
      initialApiFormData[key] = null;
    }
  }
};

onMounted(async () => {
  await Promise.all([
    fetchModuleConfiguration(),
    fetchPipelines(),
    fetchDashboards(),
    fetchCustomerViews(),
    fetchTaskViews()
  ]);
  validateFormValues();
});
</script>

<style scoped>
.selected-bar {
  background-color: var(--white-opacity-8);
  color: var(--foreground-rgb);
}
</style>